import React from "react";
import SignInModal from "./modals/SignInModal";
import SignUpModal from "./modals/SignUpModal";
import { useData } from "../providers/DataProvider";

const MODAL_COMPONENTS = {
  SIGN_IN: SignInModal,
  SIGN_UP: SignUpModal,
};

const AuthModalSwitcher = ({ modal, onClose, setModal, isMobile }) => {
  if (!Object.keys(MODAL_COMPONENTS).includes(modal?.type)) return null;

  const data = useData();

  const ModalComponent = MODAL_COMPONENTS[modal.type];

  return (
    <ModalComponent
      onClose={onClose}
      setModal={setModal}
      modal={modal}
      isMobile={isMobile}
      data={data}
    />
  );
};

export default AuthModalSwitcher;
